import PropTypes from 'prop-types';
// @mui
import { Box, TableRow, TableCell, TableHead } from '@mui/material';

// ----------------------------------------------------------------------

const visuallyHidden = {
    border: 0,
    margin: -1,
    padding: 0,
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    clip: 'rect(0 0 0 0)',
};

TableListHead.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number,
    headLabel: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func,
};

export default function TableListHead({ headLabel }) {
    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox"></TableCell>
                {headLabel.map((headCell, index) => (
                    <TableCell sx={{ whiteSpace: 'nowrap' }} key={index}>
                        <TableHead sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</TableHead>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
